import { render, staticRenderFns } from "./TagCloud.vue?vue&type=template&id=b1d049a0&scoped=true&"
import script from "./TagCloud.vue?vue&type=script&lang=js&"
export * from "./TagCloud.vue?vue&type=script&lang=js&"
import style0 from "./TagCloud.vue?vue&type=style&index=0&id=b1d049a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d049a0",
  null
  
)

export default component.exports